import { lazy } from 'react';

export const LazyIntegrationCancelSignatureRequestPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--integration-cancel-signature-request-page" */ './integration-cancel-signature-request-page'
    ),
);
